import type { Address } from "./types";

const SEPARATOR = ", ";
const BLANK = " ";

const isFilled = (value?: string): boolean => {
  const hasValue = !!value;
  const isBlank = value === BLANK;

  return hasValue && !isBlank;
};

const getAddress = (address: Address = {}): string => {
  const {
    postalCode,
    streetAddress,
    addressRegion,
    addressLocality,
  } = address;

  const parts = [
    streetAddress,
    addressLocality,
    addressRegion,
    postalCode,
  ];

  const values = parts.filter(isFilled);

  const result = values.join(SEPARATOR);

  return result;
};

export default getAddress;
